import axios from "axios";
import { isAuthenticated, getToken, updateToken } from "../security/AppSecurity";
import { getTelemetry } from "../telemetry";
import { triggerSyncReplay } from "../components/eventspwa/util/registerServiceWorker";
import { APP_VERSION } from "../constants";

const mainApiURL = process.env.NODE_ENV === "development"
  ? process.env.REACT_APP_BACKEND_API
  : window._CONFIGS.REACT_APP_BACKEND_API;

const secondApiURL = `${mainApiURL}2`;

axios.defaults.baseURL = mainApiURL;
const axiosClient = axios.create();
const telemetry = getTelemetry();

if (typeof window !== "undefined") {
  window.addEventListener("online", () => {
    triggerSyncReplay();
  });
}

function setBaseUrl(config) {
  // some logic to determine base URL here
  if (config.AlterBaseURL !== null && config.AlterBaseURL !== undefined) {
    config.baseURL = secondApiURL;
  }else{
    config.baseURL = mainApiURL;
  }
}

// Request interceptor for API calls
axiosClient.interceptors.request.use(function (config) {

  const token = getToken()
  if (token && isAuthenticated()) {
    config.headers.Authorization = `Bearer ${token}`;

    updateToken(config);
  }
  config.headers["App-Version"] = APP_VERSION

  //! Unauthenticated requests only for temporary occasions (ext orgs)
  setBaseUrl(config);

  config._telemetryStartMs = Date.now();

  telemetry?.trackApiRequest({
    method: config.method,
    url: config.url,
    baseURL: config.baseURL,
  });

  return config;
});

axiosClient.interceptors.response.use(
  (response) => {
    const durationMs =
      response.config?._telemetryStartMs != null
        ? Date.now() - response.config._telemetryStartMs
        : null;

    if (durationMs !== null) {
      telemetry?.trackPerformanceMetric("API_RESPONSE_TIME", durationMs, {
        method: response.config?.method,
        url: response.config?.url,
        status: response.status,
        cacheHit: Boolean(response.headers?.get?.("x-cache") === "HIT"),
      });
    }

    if (response?.status === 202 && response?.data?.queued) {
      window.dispatchEvent(
        new CustomEvent("pwa-sync-update", {
          detail: {
            type: "REQUEST_QUEUED",
            source: "HTTP_CLIENT",
            method: response.config?.method,
            url: response.config?.url,
          },
        })
      );

      telemetry?.trackBusinessEvent("sync_event_queued", {
        method: response.config?.method,
        url: response.config?.url,
      });
    }
    return response;
  },
  (error) => {
    telemetry?.trackApiError(error, {
      source: "axios-response-interceptor",
    });
    return Promise.reject(error);
  }
);

const http = {
  get: axiosClient.get,
  post: axiosClient.post,
  put: axiosClient.put,
  delete: axiosClient.delete,
  head: axiosClient.head,
  patch: axiosClient.patch,
};

export default http;

